import { useQuery } from '@tanstack/react-query';
import { verifyEmail } from '../api/emailConfirmApi';

export function useVerifyEmailQuery(token: string | null) {
  return useQuery({
    queryKey: ['verify-email', token],
    queryFn: () => verifyEmail(token as string),
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
    gcTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
